var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '../assets/img/cloud-01.svg';
const _hoisted_1 = { class: "flex relative justify-content gap-x-3.5" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", {
    id: "media-library-usage-logo",
    type: "default",
    class: "flex relative px-2 w-12 h-12"
}, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        class: "absolute inset-0 w-6 h-6 m-auto"
    })
], -1 /* HOISTED */);
const _hoisted_3 = { class: "flex-grow" };
const _hoisted_4 = { class: "font-normal text-sm" };
const _hoisted_5 = { class: "modal-media-usage-bar-contain relative" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "modal-media-usage-contain" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "font-bold" }, "Storage Details")
], -1 /* HOISTED */);
const _hoisted_7 = {
    key: 0,
    class: "sub-categories-media-usage"
};
const _hoisted_8 = { key: 1 };
const _hoisted_9 = {
    key: 1,
    class: "sub-categories-media-usage-container",
    style: {
        justifyContent: 'space-between',
        width: '100%',
        padding: '16px 0px 0px 0px',
    }
};
const _hoisted_10 = { style: { fontWeight: '500' } };
const _hoisted_11 = {
    key: 1,
    class: "h-full grid place-content-center"
};
import { UIModal, UIModalContent, UIModalHeader, UIDivider, UICollapse, UICollapseItem, UISpin, } from '@gohighlevel/ghl-ui';
import { computed, inject, ref, onMounted } from 'vue';
import ProgressBar from '../components/ProgressBar.vue';
import MediaServices from '@/services/MediaService';
import { formatBits } from '../util/helper';
import { CATEGORY_FOLDER, COLOR_PALETTE } from '../util/const_helper';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MediaModalUsageView',
    props: {
        settings: {},
        showModal: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const parentEmitter = inject('emitter');
        // Sample UsageData as ref
        const UsageData = ref([]);
        const isLoading = ref(true);
        // Calculate total size and widths
        let totalSize = 0;
        // Step 1: Calculate total size for each object and the entire dataset
        const calculateTotalSize = data => {
            return data.map(obj => {
                const tempTotalSize = Object.values(obj.type).reduce((acc, value) => acc + Number(value), 0);
                totalSize += Number(tempTotalSize);
                return Object.assign(Object.assign({}, obj), { size: tempTotalSize });
            });
        };
        // Step 2: Calculate the width for each object based on its size and total size
        const dataWithWidth = data => {
            const tempProcessedData = [];
            // Initialize an object to accumulate sizes for mediaLibrary and empty categories
            let mediaLibraryData = {};
            // Iterate over the data
            data.forEach((obj, index) => {
                // Check if the category is 'mediaLibrary' or empty
                if ((obj.category === 'mediaLibrary' || !obj.category) &&
                    Object.keys(mediaLibraryData).length === 0) {
                    // Add the sizes for specific content types into the mediaLibraryData object
                    mediaLibraryData = Object.assign(Object.assign({}, obj), { color: COLOR_PALETTE[index % COLOR_PALETTE.length] });
                }
                else if (obj.category === 'mediaLibrary' || !obj.category) {
                    // Accumulate the sizes for empty categories
                    mediaLibraryData.size += obj.size;
                    Object.keys(obj.type).forEach(key => {
                        mediaLibraryData.type[key] += obj.type[key];
                    });
                }
                else {
                    // Process non-mediaLibrary entries
                    const width = (obj.size / totalSize) * 100;
                    tempProcessedData.push(Object.assign(Object.assign({}, obj), { width: width.toFixed(2), color: COLOR_PALETTE[index % COLOR_PALETTE.length] }));
                }
            });
            // After iterating, add the accumulated mediaLibrary data to tempProcessedData
            if (Object.keys(mediaLibraryData).length > 0) {
                tempProcessedData.unshift(Object.assign(Object.assign({}, mediaLibraryData), { category: 'mediaLibrary', subCategory: 'funnels', width: (mediaLibraryData.size / totalSize) * 100 }));
            }
            return tempProcessedData;
        };
        const closeModal = () => {
            parentEmitter.emit('closeMediaUsageModal');
        };
        const getUsageData = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                const { data } = yield MediaServices.getGroupedLocationUsage({
                    altId: (_a = props === null || props === void 0 ? void 0 : props.settings) === null || _a === void 0 ? void 0 : _a.altId,
                    altType: (_b = props === null || props === void 0 ? void 0 : props.settings) === null || _b === void 0 ? void 0 : _b.altType,
                });
                if (data) {
                    const tempUsageData = calculateTotalSize(data);
                    const widthComputation = dataWithWidth(tempUsageData);
                    UsageData.value = widthComputation;
                }
            }
            catch (error) {
                console.error('Error fetching usage data:', error);
            }
            finally {
                isLoading.value = false;
            }
        });
        const processedData = computed(() => {
            return UsageData.value;
        });
        onMounted(() => {
            getUsageData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                id: `modal-media-library-usage-outer`,
                width: 400,
                show: _ctx.showModal,
                className: "fixed top-10 left-0 right-0 flex justify-center media-library-usage-modal-picker"
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", null, _toDisplayString(_unref(t)('common.yourStorage')), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('common.yourStorageDescription')), 1 /* TEXT */)
                        ]),
                        _createVNode(_unref(UIModalHeader), {
                            class: "flex justify-end",
                            onClose: closeModal,
                            id: "modal-header"
                        })
                    ])
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), { class: "hl-modal-content-container" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(ProgressBar, {
                                    totalUsed: _unref(formatBits)(_unref(totalSize)),
                                    segments: processedData.value,
                                    isLoading: isLoading.value
                                }, null, 8 /* PROPS */, ["totalUsed", "segments", "isLoading"])
                            ]),
                            _createVNode(_unref(UIDivider)),
                            _hoisted_6,
                            (!isLoading.value)
                                ? (_openBlock(), _createBlock(_unref(UICollapse), {
                                    key: 0,
                                    arrowPlacement: 'right'
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedData.value, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: "sub-category-collapsible-container",
                                                key: index
                                            }, [
                                                _createElementVNode("div", {
                                                    style: _normalizeStyle({
                                                        height: '12px',
                                                        width: '12px',
                                                        backgroundColor: item.color,
                                                        borderRadius: '50%',
                                                        margin: '0px 10px 0px 0px',
                                                    })
                                                }, null, 4 /* STYLE */),
                                                (item.size !== 0)
                                                    ? (_openBlock(), _createBlock(_unref(UICollapseItem), {
                                                        key: 0,
                                                        title: _unref(t)('common.' + _unref(CATEGORY_FOLDER)[item.category]),
                                                        name: index.toString(),
                                                        id: index.toString(),
                                                        class: "collapsible-category"
                                                    }, {
                                                        "header-extra": _withCtx(() => [
                                                            _createElementVNode("div", null, _toDisplayString(_unref(formatBits)(item === null || item === void 0 ? void 0 : item.size)), 1 /* TEXT */)
                                                        ]),
                                                        default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(item.type), (subItems, subIndex) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    class: "sub-categories-media-usage-container",
                                                                    key: subIndex + subItems
                                                                }, [
                                                                    (item.type[subItems])
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(subItems), 1 /* TEXT */))
                                                                        : _createCommentVNode("v-if", true),
                                                                    (item.type[subItems])
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(formatBits)(item.type[subItems])), 1 /* TEXT */))
                                                                        : _createCommentVNode("v-if", true)
                                                                ]));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "name", "id"]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('common.' + _unref(CATEGORY_FOLDER)[item.category])), 1 /* TEXT */),
                                                        _createElementVNode("div", null, _toDisplayString(_unref(formatBits)(item === null || item === void 0 ? void 0 : item.size)), 1 /* TEXT */)
                                                    ]))
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                }))
                                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createVNode(_unref(UISpin), {
                                        show: true,
                                        class: "ml-2"
                                    })
                                ]))
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
